module nullstone {
    export function getPropertyDescriptor (obj: any, name: string): PropertyDescriptor {
        if (!obj)
            return undefined;
        var type: Function = (<any>obj).constructor;
        var propDesc = Object.getOwnPropertyDescriptor(type.prototype, name);
        if (propDesc)
            return propDesc;
        return Object.getOwnPropertyDescriptor(obj, name);
    }

    export function hasProperty (obj: any, name: string): boolean {
        if (!obj)
            return false;
        if (obj.hasOwnProperty(name))
            return true;
        var type = obj.constructor;
        return type.prototype.hasOwnProperty(name);
    }
}